export const contactsData = {
    email: 'harishmullagura@gmail.com',
    phone: '+918688341982',
    address: 'Anantapur City, Andhra Pradesh State, India  - 515001',
    sheetAPI: 'https://sheetdb.io/api/v1/qkatw10ju8o9i'
}